import React, { useEffect, useRef } from "react";
import "./SpeedMenu.css";
import checkIcon from "../../assets/check.svg";

const SPEED_OPTIONS = [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2, 3];

const SpeedMenu = ({
  isOpen,
  onClose,
  currentSpeed,
  onSpeedChange,
  position,
}) => {
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="speed-menu"
      ref={menuRef}
      style={{
        bottom: position?.bottom || "auto",
        left: position?.left || 0,
      }}
    >
      {SPEED_OPTIONS.map((speed) => (
        <div
          key={speed}
          className={`speed-menu-item ${
            speed === currentSpeed ? "active" : ""
          }`}
          onClick={() => onSpeedChange(speed)}
        >
          <div className="speed-menu-item-content">
            <span>{speed === 1 ? "Обычная" : "x" + speed}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SpeedMenu;
